import { getEditor } from './../editors';
import { getRenderer } from './../renderers';
var CELL_TYPE = 'handsontable';
export default {
  editor: getEditor(CELL_TYPE),
  // displays small gray arrow on right side of the cell
  renderer: getRenderer('autocomplete')
};


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/es/cellTypes/handsontableType.js
// module id = j0tA
// module chunks = 0